__turbopack_context__.v({
  "className": "arminfont_7b692cab-module__3pyx1W__className",
  "variable": "arminfont_7b692cab-module__3pyx1W__variable",
});
